import { useMemo } from 'react'
import get from 'lodash/get'
import { l } from '@manychat/manyui'

import { Field } from 'common/fields/entities/field'
import { FilterField } from 'common/filter/models/AudienceFilter/constants'
import { SegmentsState } from 'common/filter/reducers/interfaces'
import { NotificationReason } from 'shared/api/common/schemas/notificationReason'

import { ExtendedFilterCondition } from '../interfaces'

export const useConditionValidation = (options: {
  condition: ExtendedFilterCondition
  segments: SegmentsState['byId']
  activeReasons: NotificationReason[]
  fieldDesc?: Field
}) => {
  const { condition, segments, activeReasons, fieldDesc } = options
  return useMemo(() => {
    if (
      condition.type === 'tag' &&
      condition.value &&
      !get(segments, `tag_${condition.value}.active`, false)
    ) {
      return l.translate('Tag is missing')
    }

    const isRnType = [
      FilterField.IG_RECURRING_NOTIFICATION_OPTIN,
      FilterField.IG_RECURRING_NOTIFICATION,
      FilterField.ONE_TIME_NOTIFICATION_OPTIN,
      FilterField.ONE_TIME_NOTIFICATION,
    ].includes(condition.type as FilterField)

    if (isRnType && condition.value) {
      const isActiveReasonExist = activeReasons.some(
        (reason) => reason.reason_id === condition.value,
      )
      if (!isActiveReasonExist) {
        return l.translate('Notification Topic is missing')
      }
    }

    if (!fieldDesc) {
      return l.translate('Field is missing')
    }

    return null
  }, [condition.type, condition.value, segments, fieldDesc, activeReasons])
}
